import React from 'react';

const Footer = () => {
  return (
    <div className='bg-nusblue py-24 flex flex-col items-center'>
      <div className='text-white text-lg mb-2'>
        National University of Singapore
      </div>
      <div className='text-gray-600'>21 Lower Kent Ridge Road</div>
      <div className='text-gray-600'>Singapore 119077</div>
      <div className='text-gray-600'>+65 6516 6666</div>
      <div className='text-gray-600'>
        <a href='mailto:enquiry@nus.edu.sg' className='hover:text-white'>
          enquiry@nus.edu.sg
        </a>
      </div>
      <div className='flex justify-between w-32 mt-4'>
        <a
          href='http://www.facebook.com/nus.singapore'
          target='_blank'
          rel='noopener noreferrer'
        >
          <img
            src='https://bschool.nus.edu.sg/L3/images/facebook.png'
            alt='facebook'
            width='35'
            height='35'
          />
        </a>
        <a
          href='http://twitter.com/NUSingapore'
          target='_blank'
          rel='noopener noreferrer'
        >
          <img
            src='https://bschool.nus.edu.sg/L3/images/twitter.png'
            alt='twitter'
            width='35'
            height='35'
          />
        </a>
        <a
          href='http://www.youtube.com/nuscast'
          target='_blank'
          rel='noopener noreferrer'
        >
          <img
            src='https://bschool.nus.edu.sg/L3/images/youtube.png'
            alt='youtube'
            width='35'
            height='35'
          />
        </a>
      </div>
    </div>
  );
};

export default Footer;
